import React from 'react';

function PipelineHistoryModal({ order, loading, rows, onClose, formatDateTime, getCurrentTimeZone }) {
  if (!order) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Workflow History - Order #{order.order_number}</h3>
        {loading ? (
          <div className="loading">Loading...</div>
        ) : rows.length === 0 ? (
          <div className="empty-state">No transition history yet.</div>
        ) : (
          <div className="table-wrapper">
            <table className="stock-table">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Actor</th>
                  <th>Action</th>
                  <th>From -> To</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>{formatDateTime(row.created_at, getCurrentTimeZone())}</td>
                    <td>{row.actor_username}</td>
                    <td>{row.metadata?.action || row.action}</td>
                    <td>{`${row.metadata?.from_stage || '-'} -> ${row.metadata?.to_stage || '-'}`}</td>
                    <td>{row.metadata?.reason || row.metadata?.note || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="modal-actions">
          <button type="button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default PipelineHistoryModal;
